// src/components/FounderSection.js
import "./founderSection.css";
import React from 'react';

function FounderSection() {
  return (
    <div className="founder-section">
  <div className="founder-text-wrapper">
    <p className="founder-label">FOUNDER</p>
    <h2 className="founder-name">Muskan Khan</h2>
    <p className="founder-title">Principal Designer</p>

    {/* ✅ Move description here */}
    <div className="founder-description-container">
      <p className="founder-description">
      Muskan Khan is the founder and principal designer of Saffron House, a premier interior design studio based out of Indore. </p> <br></br>

      <p className="founder-description">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. </p> <br></br>

      <p className="founder-description last">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. </p> <br></br>
      
    </div>
  </div>

  <div className="founder-image-container">
    <img 
      src="/images/Muskan-Khan-Profile.jpg" 
      alt="Muskan Khan" 
      className="founder-image"
    />
  </div>
</div>
  );
}

export default FounderSection;
